var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUploadImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.25V19.75H15.5V5.19531L15.2891 4.96094L10.7891 0.460938L10.5547 0.25H0.5ZM2 1.75H9.5V6.25H14V18.25H2V1.75ZM11 2.82812L12.9219 4.75H11V2.82812ZM11.8203 8.5C11.4072 8.5 11.0703 8.83691 11.0703 9.25C11.0703 9.66309 11.4072 10 11.8203 10C12.2334 10 12.5703 9.66309 12.5703 9.25C12.5703 8.83691 12.2334 8.5 11.8203 8.5ZM6.5 9.69531L5.96094 10.2109L2.96094 13.2109L4.03906 14.2891L6.5 11.8281L8.21094 13.5391L8.75 14.0547L9.28906 13.5391L10.25 12.5781L11.9609 14.2891L13.0391 13.2109L10.7891 10.9609L10.25 10.4453L9.71094 10.9609L8.75 11.9219L7.03906 10.2109L6.5 9.69531Z",
    fill: "#909294"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUploadImg);
export default __webpack_public_path__ + "static/media/profile-upload-img.1606901814c2b504a3fe9a45a942e5ce.svg";
export { ForwardRef as ReactComponent };